import type { ButtonProps } from '../Button';
import { Button } from '../Button';

export function Pill(props: Omit<ButtonProps, 'kind'>) {
    return <Button {...props} kind="pill" size="small" />;
}
